export const INVALID_EMAIL = 'INVALID_EMAIL';
export const TOO_SHORT_STRING = 'TOO_SHORT_STRING';
export const TOO_LONG_STRING = 'TOO_LONG_STRING';
export const INVALID_ENUM_VALUE = 'INVALID_ENUM_VALUE';
export const INVALID_TOKEN = 'INVALID_TOKEN';
export const INVALID_TOKEN_LENGTH = 'INVALID_TOKEN_LENGTH';
export const INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER';
export const NOT_MATCHES_TO_PATTERN = 'NOT_MATCHES_TO_PATTERN';
export const INVALID_LIMIT_VALUE = 'INVALID_LIMIT_VALUE';
export const FIELD_MUST_BE_AN_ARRAY = 'FIELD_MUST_BE_AN_ARRAY';
export const ARRAY_EMPTY = 'ARRAY_EMPTY';
export const ARRAY_MUST_BE_UNIQUE = 'ARRAY_MUST_BE_UNIQUE';
export const ARRAY_INVALID_SIZE = 'ARRAY_INVALID_SIZE';
export const ARRAY_INVALID_CONTENT_TYPE = 'ARRAY_INVALID_CONTENT_TYPE';
export const FIELD_INVALID_VALUE = 'FIELD_INVALID_VALUE';
export const INVALID_DATE = 'INVALID_DATE';
export const FIELD_INVALID_NUMBER = 'FIELD_INVALID_NUMBER';
export const FIELD_INVALID_LENGTH = 'FIELD_INVALID_LENGTH';
